import React from "react";
import { MessageSquareText } from "lucide-react";

import { Input } from "../../../../components/ui/input";

import FaixaOfertas from "../../FaixaOfertas";
import Bloco from "./Bloco";

export default function SecaoFaixa({ config, onMudar }) {
  const previa = { estado: "ativo", total: 4, config: { texto_faixa: config.texto_faixa } };
  return (
    <Bloco icone={MessageSquareText} titulo="Aviso no cardápio"
      subtitulo={<>A faixa que o cliente vê no topo do cardápio. Use {"{n}"} onde entra a quantidade de ofertas dele.</>}>
      <Input value={config.texto_faixa || ""} maxLength={120} onChange={(e) => onMudar("texto_faixa", e.target.value)} aria-label="Texto da faixa" />
      <p className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground mt-4 mb-2">Como o cliente vê</p>
      <div className="rounded-xl border border-dashed p-3 pb-0 bg-muted/30 dark:bg-transparent" data-e2e="previa-faixa">
        <FaixaOfertas ofertasDia={previa} darkMode={document.documentElement.classList.contains("dark")} />
      </div>
    </Bloco>
  );
}
